/* eslint-disable @typescript-eslint/no-unused-vars */

import ImmersalBase from "./immersal.base";
import { CameraIntrinsics, LocalizeResult, ResponseLocalizeImage } from "./immersal.common";
import BridgeImmersal from "../bridge/bridge.immersal";
import { Matrix } from "babylonjs";  // eventually remove dependency on BabylonJS

export default class ImmersalAppCloud extends ImmersalBase {
  
  private bridge: BridgeImmersal;
  
  constructor(token: string, mapIds: number[]) {
    super(token, mapIds);
    
    this.bridge = new BridgeImmersal();
  }

  public override async init(): Promise<void> {
    console.warn("immersal.app.cloud.init not required.");
    return Promise.resolve();
  }

  public override async loadMap(_url: string): Promise<void> {
    console.warn("immersal.app.cloud.loadMap not required.");
    return Promise.resolve();
  }

  public override async localize(_imageData?: Uint8ClampedArray, _imageWidth?: number, _imageHeight?: number, _intrinsics?: CameraIntrinsics): Promise<LocalizeResult> {
    try {
      const data : ResponseLocalizeImage = await this.bridge.localizeOnCloud(this.token, this.mapIds) as ResponseLocalizeImage;
      if( data.error && data.error !== 'none' ) {
        throw new Error('immersal.app.cloud.localize: failed - ' + data.error);
      }
      const locResult: LocalizeResult = {
        success: false,
        confidence: 0,
        matrix: undefined,
      };
      if (data.success) {
        let matrix = new Matrix();
        matrix.setRowFromFloats(0, data.r00, -data.r01, -data.r02, data.px);
        matrix.setRowFromFloats(1, data.r10, -data.r11, -data.r12, data.py);
        matrix.setRowFromFloats(2, data.r20, -data.r21, -data.r22, data.pz);
        matrix.setRowFromFloats(3, 0, 0, 0, 1);
        matrix = matrix.transpose();

        locResult.success = true;
        locResult.confidence = data.confidence!;
        locResult.matrix = new Float32Array(16);
        locResult.map = data.map;
        matrix.toArray(locResult.matrix, 0);
      }
      return locResult;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(`${error.message || error}`);
      } else {
        throw new Error(String(error));
      }
    }
  }
}